import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import recordingSegmentsFetchFailed, {
	type RecordingSegmentsFetchFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/recordingSegmentsFetchFailed';
import recordingSegmentsFetched, {
	type RecordingSegmentsFetchedAction,
} from '@Application/Beneficiaries/Interviews/Actions/recordingSegmentsFetched';
import type FetchRecordingSegments from '@Application/Beneficiaries/Interviews/Queries/FetchRecordingSegments';
import type { RecordingSegmentPayload } from '@Application/Beneficiaries/Interviews/transferRecordingSegment';
import { get } from '@Domain/Api';
import ApiError from '@Infra/FetchLib/ApiError';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import type * as React from 'react';

type Actions = RecordingSegmentsFetchedAction | RecordingSegmentsFetchFailedAction;

/**
 * Dispatched by the transfer handler through its own `dispatch`. A rejection here is caught by the
 * handler's own resume `try`/`catch`, which discards it: the resume read is an optimisation only,
 * never a hard requirement of the transfer.
 */
const fetchRecordingSegments = (query: FetchRecordingSegments) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<RecordingSegmentPayload[]>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/recordings/${query.recordingId}/segments`,
			);

			const action = recordingSegmentsFetched(
				payload,
				query.interviewId,
				query.recordingId,
				query.subject.typeKey,
				query.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = recordingSegmentsFetchFailed(
				extractMessages(error),
				error instanceof ApiError ? error.status : null,
			);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};

export default fetchRecordingSegments;
